"use client";

import { useFavorite } from "@/providers/favorite-provider";
import { FavoritesTabs } from "@/components/favorites-tabs";
import { FavoritesList } from "@/components/favorites-list";
import { FavoritesEmpty } from "@/components/favorites-empty";
import { FavoritesSkeleton } from "@/components/favorites-skeleton";
import { Breadcrumb } from "@/components/breadcrumb";
import { ConfirmModal } from "@/components/confirm-modal";
import { Toast } from "@/components/toast";
import { Layout } from "@/components/layout";
import { useInfiniteScroll } from "@/hooks/use-infinite-scroll";
import { getPortalHost } from "@/utils/detail-url";
import styles from "./favorites-page.module.css";

const BREADCRUMB_ITEMS = [
  { label: "Início", href: "https://www.webmotors.com.br" },
  { label: "Favoritos" },
];

export function FavoritesPage() {
  const {
    isLoading,
    isLoadingMore,
    hasMore,
    loadMore,
    activeTab,
    setActiveTab,
    currentFavorites,
    requestRemove,
    confirmRemoveId,
    cancelRemove,
    confirmRemove,
    removingId,
    lastRemoved,
    dismissToast,
  } = useFavorite();

  const showEmpty = !isLoading && currentFavorites.length === 0;
  const showList = !isLoading && currentFavorites.length > 0;

  const sentinelRef = useInfiniteScroll(loadMore, {
    enabled: showList && hasMore,
  });

  return (
    <Layout>
      <div className={styles.page}>
        <Breadcrumb items={BREADCRUMB_ITEMS} />

        <div className={styles.panel}>
          <div className={styles.panelHeader}>
            <h1 className={styles.title}>Favoritos</h1>
            <FavoritesTabs
              activeTab={activeTab}
              onTabChange={setActiveTab}
            />
          </div>

          <div className={styles.panelContent}>
            {isLoading && <FavoritesSkeleton />}
            {showEmpty && (
              <FavoritesEmpty
                searchUrl={`${getPortalHost()}/${activeTab === "motos" ? "motos" : "carros"}`}
              />
            )}
            {showList && (
              <FavoritesList
                favorites={currentFavorites}
                onRemove={requestRemove}
                removingId={removingId}
              />
            )}
            {showList && isLoadingMore && (
              <div
                className={styles.loadingMore}
                data-testid="favorites-loading-more"
                role="status"
                aria-label="Carregando mais favoritos"
              >
                <span className={styles.spinner} aria-hidden="true" />
              </div>
            )}
            {showList && hasMore && (
              <div
                ref={sentinelRef}
                data-testid="favorites-scroll-sentinel"
                aria-hidden="true"
              />
            )}
          </div>
        </div>
      </div>

      {confirmRemoveId !== null && (
        <ConfirmModal
          onConfirm={confirmRemove}
          onCancel={cancelRemove}
        />
      )}

      {lastRemoved && (
        <Toast
          message="Veículo removido dos Favoritos."
          onDismiss={dismissToast}
        />
      )}
    </Layout>
  );
}
